<template>
  <div class="flex items-center gap-2">
    <span
      v-if="isDeleted"
      class="text-sm italic text-gray-500 dark:text-gray-400"
      data-test="local-group-deleted"
    >
      Gelöschte Gruppe
    </span>
    <USelect
      v-else
      :model-value="modelValue || undefined"
      :items="items"
      :disabled="disabled"
      class="w-full text-sm"
      placeholder="Gruppe auswählen …"
      data-test="local-group-select"
      @update:model-value="onSelect"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { LocalGroup } from '@/types'

// Auswahl einer lokalen Gruppe. Der Wert ist der Mapping-Schlüssel
// `local:{groupId}`; angezeigt wird immer der Gruppenname.
const props = defineProps<{
  modelValue: string
  groups: LocalGroup[]
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', key: string): void
}>()

const items = computed(() => props.groups.map((g) => ({ label: g.name, value: `local:${g.id}` })))

// Ein gesetzter Schlüssel ohne passende Gruppe gehört zu einer gelöschten Gruppe.
const isDeleted = computed(
  () => !!props.modelValue && !items.value.some((i) => i.value === props.modelValue),
)

function onSelect(value: unknown) {
  if (typeof value === 'string' && value) emit('update:modelValue', value)
}
</script>
